import React from 'react';
import { components } from 'react-select';

// Opt-in react-select parts for multi-selects in narrow filter bars:
// the control shows the first selected chip plus a "+N more" chip (hover lists every
// selection), and the menu keeps selected options visible with a checkbox.

const CompactMultiValue = (props) => {
    const { index, selectProps, data } = props;
    const selected = selectProps?.value || [];

    if (index === 0) {
        return (
            <div title={data?.label} style={{ display: 'flex', minWidth: 0 }}>
                <components.MultiValue {...props} />
            </div>
        );
    }

    if (index === 1) {
        const allLabels = selected.map((item) => item?.label).join('\n');
        return (
            <span className="compact-multi-more" title={allLabels}>
                +{selected.length - 1} more
            </span>
        );
    }

    return null;
};

const CompactOption = (props) => (
    <components.Option {...props}>
        <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <input type="checkbox" checked={props.isSelected} readOnly style={{ pointerEvents: 'none' }} />
            <span>{props.label}</span>
        </span>
    </components.Option>
);

export const compactMultiSelectComponents = {
    MultiValue: CompactMultiValue,
    Option: CompactOption,
};
